import fatherandson from "../../assets/images/about/fatherandson.jpeg";

import "../fonts/schnoerkel.css";

export default function Example() {
    return (
        <div className="overflow-hidden bg-white py-16  px-8">
            <div className="flex flex-row justify-center items-center lg:space-x-16 space-x-0 flex-wrap">
                <div className="w-full lg:w-1/3 xl:w-1/4 mt-8 lg:mt-0 flex justify-center">
                    <img
                        src={fatherandson}
                        alt="fatherandson"
                        className="aspect-[5/5] w-[37rem] object-cover object-[0%_25%] rounded-xl"
                    />
                </div>
                <div className="w-full lg:w-1/2 xl:w-1/3 text-center lg:text-left h-full mt-8 lg:mt-0">
                    <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                        Herzlich Willkommen
                    </h2>
                    <p className="mt-6 text-xl/8 text-black">
                        Wir möchten Sie herzlichst in unser gemütliches
                        Gartenparadies auf eine kurze Urlaubsreise einladen.
                        Weitab vom Alltagslärm, bieten wir Ihnen einige Stunden
                        Erholung im Grünen. Wir servieren Ihnen griechische und
                        deutsche Küche in Saisonalen und mediterranen Flair.
                        Auch für unsere jüngeren Gäste ist mit unserem
                        dazugehörigen Spielplatz für sehr viel Spaß gesorgt.
                        Selbstverständlich genießen unsere Gäste auch das
                        Wechselnde Mittagstisch – Angebot.
                    </p>
                    <p className="mt-6 text-xl/7 text-black">
                        Wir freuen uns auf Ihren Besuch und wünschen Ihnen einen
                        angenehmen Aufenthalt.
                    </p>
                    <p className="mt-10 text-6xl customFont">
                        Ihr En Edem Team
                    </p>
                </div>
            </div>
        </div>
    );
}
